const FootNotesConfig = [
    {
        span: 14,
        classes: "marginTop-48",
        height: "93px",
    },
]

export const FootNotesLabs = [
    {
        span: 8,
        classes: "marginTop-16",
        height: "200px",
    },
]

export default FootNotesConfig
